module.exports = __webpack_public_path__ + "static/media/logo.02d2580b.jpg";